import { Component } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

import PricingPlansCardHeader from './PricingPlansCardHeader';
import PricingPlansCardContent from './PricingPlansCardContent';
import withComponentName from '../../../../../../decorators/withComponentName';

import Styles from './style.module.scss';
import PricingPlansOverlay from '../PricingPlansOverlay';

const cx = classNames.bind(Styles);

export class PricingPlansCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showOverlay: false,
    };
    this.showOverlay = this.showOverlay.bind(this);
    this.hideOverlay = this.hideOverlay.bind(this);
  }

  showOverlay() {
    if (isMobile) {
      this.setState({
        showOverlay: true,
      }, () => {
        document.querySelector('body').setAttribute('style', 'overflow:scroll !important; -webkit-overflow-scrolling:touch !important;');

        setTimeout(() => {
          document.querySelector('#overlay_contactus_form').focus();
        }, 0);
      });
    }
  }

  hideOverlay() {
    if (isMobile) {
      this.setState({
        showOverlay: false,
      }, () => {
        document.querySelector('body').removeAttribute('style');
      });
    }
  }

  scrollToForm(fromOverlay) { // scroll to form for overlay
    if (fromOverlay) {
      document.querySelector('#overlay_contactus_form').scrollIntoView({
        behavior: 'smooth',
      });
    } else {
      document.querySelector('#contactus-form').scrollIntoView({
        behavior: 'smooth',
      });
    }
  }

  render() {
    const { showOverlay } = this.state;
    const {
      logo, header, content, activePlanTab, index,
    } = this.props;
    const {
      free,
      comingSoon,
      title,
      priceMonthly,
      priceAnnually,
      contactUs,
      contactUsForPrice,
      isQuarterly,
    } = header;

    return (
      <>
        <div className={cx('PricingPlansCard', { [`${activePlanTab}`]: true })}>
          <PricingPlansCardHeader
            index={index}
            logo={logo}
            title={title}
            priceMonthly={priceMonthly}
            priceAnnually={priceAnnually}
            free={free}
            comingSoon={comingSoon}
            contactUs={contactUs}
            contactUsForPrice={contactUsForPrice}
            isQuarterly={isQuarterly}
            className={activePlanTab}
            onShowOverlay={this.showOverlay}
            onScrollToForm={this.scrollToForm}
          />

          <PricingPlansCardContent
            content={content}
            priceMonthly={priceMonthly}
            priceAnnually={priceAnnually}
            contactUs={contactUs}
            isQuarterly={isQuarterly}
            hideForMobile
          />
        </div>

        {showOverlay && (
          <PricingPlansOverlay
            showOverlay={showOverlay}
            title={title}
            hideOverlay={this.hideOverlay}
            isMobile={isMobile}
            activePlanTab={activePlanTab}
          />
        )}
      </>
    );
  }
}

PricingPlansCard.propTypes = {
  logo: PropTypes.string.isRequired,
  header: PropTypes.instanceOf(Object).isRequired,
  content: PropTypes.instanceOf(Array).isRequired,
};

export default withComponentName(PricingPlansCard);
